import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ILocation } from '@nimbus-global/features/shared/services/api/i-location.models';
import { BaseLocationSelector } from '../../base-location-selector';

@Component({
  standalone: false,
  selector: 'nimbus-location-selector-container',
  templateUrl: './location-selector-container.component.html',
  styleUrls: ['./location-selector-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationSelectorContainerComponent extends BaseLocationSelector implements OnInit {
  public selectedLocation: ILocation;

  public ngOnInit(): void {
    super.ngOnInit();
  }

  public onLocationSelected(location: ILocation): void {
    this.selectedLocation = location;
  }

  public apply(): void {
    this.selectedLocation && this.getLocationService.redirectToLocation(this.selectedLocation);
  }
}
